/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

import type { CCMRole } from './types'

export const roleMessages = defineMessages<CCMRole>({
  admin: {
    id: 'roles-assignments.ccm-access.role.admin',
    defaultMessage: 'Admin',
  },
  viewer: {
    id: 'roles-assignments.ccm-access.role.viewer',
    defaultMessage: 'Viewer',
  },
})

const messages = defineMessages({
  allConnectedClustersRole: {
    id: 'roles-assignments.ccm-access.role',
    defaultMessage: 'Role for all Connected clusters',
  },
  allConnectedClustersRoleHelp: {
    id: 'roles-assignments.ccm-access.role-help',
    defaultMessage: 'This role will be applied to all Connected clusters.',
  },
  globalRoleDropdownAccessibleLabel: {
    id: 'cloud-landing-page.global-role-dropdown-accessible-label',
    defaultMessage: 'Select role for all Connected clusters',
  },
  clusterTableColumnLabel: {
    id: 'roles-assignments.ccm-access.table.cluster-name',
    defaultMessage: 'Cluster',
  },
  rolesTableColumnLabel: {
    id: 'roles-assignments.ccm-access.table.role',
    defaultMessage: 'Role',
  },
})

export default messages
